import script from "./NavFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./NavFooter.vue?vue&type=script&setup=true&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=7c34e6c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c34e6c6"]])

export default __exports__